import React from 'react';
import { FullscreenOutlined } from '@ant-design/icons';

import { BlockWrapper, IconButton, RadioGroup, Chart as NpChart, NoData, Spin } from 'components';

import useChartOptions from './hooks/useChartOptions';
import { useFilterOptions } from './hooks/useFilterOptions';

import { IChartProps } from './Chart.types';

import './Chart.styles.scss';

const Chart = ({
  data,
  loading,
  granularity,
  granularities,
  titleClass = '',
  title,
  width,
  height,
  enableExpend,
  onEvents,
  onExpand,
  onChangeGranularity,
  ...props
}: IChartProps) => {
  const filterOptions = useFilterOptions(granularities);
  const chartOptions = useChartOptions(data, { granularity });

  return (
    <BlockWrapper {...props}>
      <div className="np-hashrate-chart__header">
        <div className="np-hashrate-chart__header-title">
          <BlockWrapper.Title className={titleClass}>{title}</BlockWrapper.Title>
        </div>

        <div className="np-hashrate-chart__actions">
          <RadioGroup
            size="small"
            value={granularity}
            options={filterOptions}
            onChange={onChangeGranularity}
            className="np-hashrate-chart__switchers"
          />

          <div>
            {enableExpend && <IconButton icon={<FullscreenOutlined />} tooltip="tooltip.expand" onClick={onExpand} />}
          </div>
        </div>
      </div>

      {loading && <Spin />}

      {!loading && !data && <NoData />}

      {!loading && data && chartOptions && (
        <NpChart width={width} height={height} option={chartOptions} onEvents={onEvents} />
      )}
    </BlockWrapper>
  );
};

export default Chart;
